// Closed, curated vocabularies for the artist's PERSONA (Plan 13, spec §4.2).
// The persona describes axes ORTHOGONAL to the R3.1 `sonic_traits`: how an artist
// performs (`temperament`) and whom they draw from (`influences`) — never
// genre/era/timbre/vibe/energy. Curated by the Tech Lead; deliberately small so
// the prompt stays clean (same argument as R3.1 §3).
// `influences` — closed vocabulary of archetype artists / currents.
export const PERSONA_INFLUENCES = [
    "the_beatles",
    "led_zeppelin",
    "miles_davis",
    "daft_punk",
    "nina_simone",
    "radiohead",
    "james_brown",
    "johnny_cash",
    "bjork",
    "kraftwerk",
    "bob_marley",
    "aphex_twin",
];
// `temperament` — 1..5 scalar axes describing HOW an artist performs.
// `3` is the neutral point and injects nothing (zero regression).
export const PERSONA_TEMPERAMENT_AXES = ["discipline", "boldness", "experimental"];
//# sourceMappingURL=vocabulary.js.map